import { useMemo } from 'react';
import { useRouteParams } from '../_hooks/useRouteParams';
import { useDefaultTemplateQuery } from './api/useDefaultTemplateQuery';
import { useWidgetTemplateQuery } from './api/useWidgetTemplateQuery';

export const usePersonalFinanceTemplate = () => {
  const routeParams = useRouteParams<{ templateId: string }>();

  const { templateId } = routeParams;

  const defaultTemplateQueryInfo = useDefaultTemplateQuery({
    enabled: !templateId,
  });

  const templateQueryInfo = useWidgetTemplateQuery({
    templateId,
  });

  const queryInfo = templateId ? templateQueryInfo : defaultTemplateQueryInfo;

  const data = useMemo(() => {
    if (!queryInfo.data) {
      return null;
    }

    if (templateId && templateQueryInfo.data) {
      return templateQueryInfo.data;
    }

    if (!templateId && defaultTemplateQueryInfo.data) {
      return { name: '', widgets: defaultTemplateQueryInfo.data };
    }

    return null;
  }, [queryInfo.data, templateId, templateQueryInfo.data, defaultTemplateQueryInfo.data]);

  return { ...queryInfo, data };
};
